export default function WorkingHourglass({ size = 16, className = "" }) {
  return (
    <span
      className={`working-hourglass${className ? ` ${className}` : ""}`}
      style={{ "--working-hourglass-size": `${size}px` }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <path d="M7 3h10M7 21h10M8 4.5c0 3.6 1.7 5.5 4 7.5-2.3 2-4 3.9-4 7.5m8-15c0 3.6-1.7 5.5-4 7.5 2.3 2 4 3.9 4 7.5" />
        <path className="working-hourglass__sand" d="M9.6 7h4.8c-.3 1.6-1.1 2.8-2.4 3.9C10.7 9.8 9.9 8.6 9.6 7Zm0 10c.3-1.6 1.1-2.8 2.4-3.9 1.3 1.1 2.1 2.3 2.4 3.9H9.6Z" />
      </svg>
    </span>
  );
}
